import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTodayDeliveryStats } from "../services/deliveryService";
import { getContainerBalanceTotalCount } from "../services/customerService"; // ✅ Corrected import
import Loader from "../components/Loader";
import { generateCustomerBackupPdf } from "../services/invoiceService";

const Reports = () => {
  const [stats, setStats] = useState({
    total_customers: 0,
    total_deliveries: 0,
    total_due_amount: 0,
  });

  const [balance, setBalance] = useState({
    pet_container_customers: 0,
    cool_container_customers: 0,
  });

  const [loading, setLoading] = useState(true);

  const fetchTodayStats = async () => {
    try {
      const response = await getTodayDeliveryStats();
      if (response.success) {
        setStats(response.data);
      }
    } catch (error) {
      console.error("Error fetching today's stats:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchContainerBalanceCount = async () => {
    try {
      const res = await getContainerBalanceTotalCount();
      if (res.success) {
        setBalance(res.data);
      }
    } catch (error) {
      console.error("Error fetching container balances:", error.message);
    }
  };

  useEffect(() => {
    fetchTodayStats();
    fetchContainerBalanceCount();
  }, []);


  
  const downloadCustomerBackup = async () => {
    try {
      const res = await generateCustomerBackupPdf();
      if (res.data.success && res.data.url) {
        window.open(res.data.url, "_blank");
      } else {
        alert("Failed to generate customer backup.");
      }
    } catch (err) {
      console.error("Download failed:", err.message);
      alert("Error downloading customer backup.");
    }
  };


  return (
  <div className="p-1">
    <h2 className="text-xl font-bold mb-2 text-white">📊 Reports</h2>

    {/* Live Summary */}
    <div className="bg-white rounded-lg shadow p-1 text-sm text-gray-800 mb-6">
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Section Heading */}
          <h3 className="text-xs text-gray-400 uppercase font-semibold mb-2 mt-4 tracking-wide">
            🔹 Today’s Summary
          </h3>

          {/* Today’s Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-center">
            <div className="bg-blue-50 rounded-lg shadow p-2 min-h-[85px] flex flex-col justify-center">
              <div className="text-gray-600 text-sm">👥 Customers</div>
              <div className="font-bold text-blue-600 text-xl">
                {stats.total_customers}
              </div>
            </div>
            <div className="bg-blue-50 rounded-lg shadow p-2 min-h-[85px] flex flex-col justify-center">
              <div className="text-gray-600 text-sm">🚚 Deliveries</div>
              <div className="font-bold text-blue-600 text-xl">
                {stats.total_deliveries}
              </div>
            </div>
            <div className="bg-blue-50 rounded-lg shadow p-2 min-h-[85px] flex flex-col justify-center">
              <div className="text-gray-600 text-sm">💰 Sale</div>
              <div className="font-bold text-green-600 text-xl">
                ₹{stats.total_due_amount}
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t my-4" />

          {/* Section Heading */}
          <h3 className="text-xs text-gray-400 uppercase font-semibold mb-2 tracking-wide">
            🧾 Product Container Balances (All-Time)
          </h3>

          {/* All-Time Container Balances */}
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 text-center">
            <div className="bg-yellow-50 rounded-lg shadow p-2 min-h-[85px] flex flex-col justify-center">
              <div className="text-gray-600 text-sm">🧴 PET Bottles with Customers</div>
              <div className="font-bold text-yellow-700 text-xl">
                {balance.pet_container_customers}
              </div>
            </div>
            <div className="bg-indigo-50 rounded-lg shadow p-2 min-h-[85px] flex flex-col justify-center">
              <div className="text-gray-600 text-sm">🧊 Cool Cans with Customers</div>
              <div className="font-bold text-indigo-700 text-xl">
                {balance.cool_container_customers}
              </div>
            </div>
          </div>
        </>
      )}
    </div>

   
 {/* Report Links */}
      <ul className="space-y-3 mb-4">
        <li>
          <Link
            to="/report/daily-summary"
            className="block p-2 rounded bg-blue-100 text-blue-800 shadow"
          >
            📅 Today’s Delivery Summary
          </Link>
        </li>

         <li>
          <Link
            to="/report/customer-backup"
            className="block p-3 rounded-lg bg-green-100 text-green-800 hover:bg-green-200 transition shadow"
          >
            📥 Download Customer Backup
          </Link>
        </li>
      </ul>


    </div>
  );
};

export default Reports;